var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5C11.1823 5.5 11.3572 5.57243 11.4861 5.70136C11.6151 5.8303 11.6875 6.00516 11.6875 6.1875V10.3125H15.8125C15.9948 10.3125 16.1697 10.3849 16.2986 10.5139C16.4276 10.6428 16.5 10.8177 16.5 11C16.5 11.1823 16.4276 11.3572 16.2986 11.4861C16.1697 11.6151 15.9948 11.6875 15.8125 11.6875H11.6875V15.8125C11.6875 15.9948 11.6151 16.1697 11.4861 16.2986C11.3572 16.4276 11.1823 16.5 11 16.5C10.8177 16.5 10.6428 16.4276 10.5139 16.2986C10.3849 16.1697 10.3125 15.9948 10.3125 15.8125V11.6875H6.1875C6.00516 11.6875 5.8303 11.6151 5.70136 11.4861C5.57243 11.3572 5.5 11.1823 5.5 11C5.5 10.8177 5.57243 10.6428 5.70136 10.5139C5.8303 10.3849 6.00516 10.3125 6.1875 10.3125H10.3125V6.1875C10.3125 6.00516 10.3849 5.8303 10.5139 5.70136C10.6428 5.57243 10.8177 5.5 11 5.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.8be07add4ee7c7a95622e4544cacfa02.svg";
export { ForwardRef as ReactComponent };